import { _getLogger } from '@doxyme/analytics';
import { Specs, BasicObservable } from '@doxyme/extensions-common';
import AppletCapability from '../applet';

type Constraints = Specs.DashboardApplet.Constraints;
type Applet = Specs.DashboardApplet.Applet;

const { DashboardApplet } = Specs;

/**
 * Dashboard Applet stores the frames registered to any extension using this capability.
 */
export default class DashboardAppletCapability extends AppletCapability<Constraints> {
  static id = DashboardApplet.id;

  protected override readonly hasDynamicHeight = true;

  constructor() {
    super(DashboardApplet);

    this.handlers.push(
      [DashboardApplet.Actions.Attach, this.attach.bind(this)],
      [DashboardApplet.Actions.Detach, this.detach.bind(this)],
    );
  }

  /**
   * Get all frames registered to this capability
   * @description This is an observable that will update whenever frames are added or removed.
   * See {@link BasicObservable} for more information.
   * @returns All frames registered to this capability, as an observable.
   * @example
   * ```ts
   * const frames = dashboardApplet.getFrames();
   * frames.onChange((frames) => {
   *  console.log('Frames changed', frames);
   * });
   * ```
   */
  getFrames(): BasicObservable<Applet[]> {
    return this._frames;
  }
}
